import React from 'react';
import './TeamItem.css';

import { Link } from 'react-router-dom';



const TeamItem = (props) => {

    // Destructuring props
    const { id, image, name, title, team } = props;

    return (

        <div className='team-item' key={id}>

            {/* Team member Picture */}
            <img src={image} alt={title} />

            {/* Team member Content */}
            <div className='content'> 


                {/* Team member Intro */}
                <div className='intro'>
                    <Link
                        to={{
                            pathname: '/RadaNaukowa/' + id,
                        }}
                        state={team}>
                        <h3>{name}</h3> {/* Team member name */}
                    </Link>
                    <p>{title}</p> {/* Team member title */}
                </div>

            </div> 
            
        </div>
    );
}

export default TeamItem;